// Draggable - a lightweight, responsive, modern drag & drop library: https://shopify.github.io/draggable/

require('@shopify/draggable/lib/draggable.bundle.js');
require('@shopify/draggable/lib/draggable.bundle.legacy.js');
require('@shopify/draggable/lib/draggable.js');
window.Sortable = require('@shopify/draggable/lib/sortable.js');
window.Droppable = require('@shopify/draggable/lib/droppable.js');
window.Swappable = require('@shopify/draggable/lib/swappable.js');
require('@shopify/draggable/lib/plugins.js');
require('@shopify/draggable/lib/plugins/collidable.js');
require('@shopify/draggable/lib/plugins/resize-mirror.js');
require('@shopify/draggable/lib/plugins/snappable.js');
require('@shopify/draggable/lib/plugins/swap-animation.js');
